import { useEffect, useState } from "react";
import PieChart from "../charts/PieChart";

export default function BantuanCovid({ data }) {
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: []
  })

  useEffect(() => {
    const mapData = {}
    const rawData = {
      labels: [],
      datasets: [
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 0.8)',
            'rgba(4,135,55, 0.6)',
            'rgba(4,135,55, 0.3)',
            'rgba(4,135,55, 0.2)',
            'rgba(4,135,55, 0.1)',
          ],
          borderColor: [
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
            'rgba(4,135,55, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };
    data.map(item => {
      if(item["bantuan_usaha"] === 3){
        if (mapData["Kemungkinan akan dapat"] !== undefined) {
          mapData["Kemungkinan akan dapat"] += 1
        }else{
          mapData["Kemungkinan akan dapat"] = 1;
        }
      }else if(item["bantuan_usaha"] === 1){
        if (mapData["Mendapat bantuan"] !== undefined) {
          mapData["Mendapat bantuan"] += 1
        }else{
          mapData["Mendapat bantuan"] = 1;
        }
      }else if(item["bantuan_usaha"] === 2){
        if (mapData["Tidak mendapat bantuan"] !== undefined) {
          mapData["Tidak mendapat bantuan"] += 1
        }else{
          mapData["Tidak mendapat bantuan"] = 1;
        }
      }
      return item
    })
    rawData.labels = Object.keys(mapData)
    rawData.datasets[0].data = []
    rawData.labels.map(item => {
      rawData.datasets[0].data.push(((mapData[item]/data.length)*100).toFixed(1))
      return item
    })
    setGraphData(rawData)
  }, [data]);

  return <PieChart data={graphData} />
}